<template>
  <main class="layout__corpo">
    <slot />
  </main>
</template>

<script>
export default {
  name: 'LayoutBasico',
}

</script>

<style lang="scss" scoped>
.layout__corpo {
  height: auto;
  width: inherit;
}

</style>
